import * as React from 'react';
import * as PropTypes from 'prop-types';
import Modal from '@roo/roo/Modal';
import Form, { Field } from '@roo/roo/Form';
import { EditorBarProps } from './interface';

class EditorBar extends React.Component<EditorBarProps, any> {
  static propsTypes = {
    insertText: PropTypes.func,
    linkModelPopupContainer: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.func]),
  }

  static defaultProps = {
    insertLink: () => { },
    linkModelPopupContainer: undefined,
  }

  state = {
    showLink: false,
  }

  private linkText = '';

  private linkUrl = '';

  renderColors = () => {
    const colors = [
      '#ffffff', '#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc',
      '#9933ff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff',
      '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff',
      '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2',
      '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466',
    ];
    return (
      colors.map((color) => (
        <option
          key={color}
          value={color}
        />
      ))
    );
  }

  showLinkModal = () => {
    this.setState({
      showLink: true,
    });
  }

  closeLinkModal = () => {
    this.setState({
      showLink: false,
    });
  }

  confirmLink = () => {
    const { insertLink } = this.props;
    const link = `<a href="${this.linkUrl}" target="_blank">${this.linkText}</a>`;
    this.setState({
      showLink: false,
    });
    insertLink(link);
  }

  handleChange = (name, value) => {
    this[name] = value;
  }

  renderLinkModal = () => {
    const formValue = {
      linkText: '',
      linkUrl: '',
    };
    const rules = {
      linkText: {
        required: true,
        message: '链接文本必填',
      },
      linkUrl: {
        required: true,
        message: '链接地址必填',
      },
    };

    const { linkModelPopupContainer } = this.props;

    return (
      <Modal
        title="插入链接"
        openText="插入"
        visible={this.state.showLink}
        onCancel={this.closeLinkModal}
        onConfirm={this.confirmLink}
        popupContainer={linkModelPopupContainer}
      >
        <Form
          value={formValue}
          rules={rules}
          cols={{
            field: { span: 8, offset: 0 },
            label: { span: 3, offset: 0 },
          }}
          onChange={this.handleChange}
        >
          <Field
            label="链接文本"
            name="linkText"
          />
          <Field
            label="链接地址"
            name="linkUrl"
          />
        </Form>
      </Modal>
    );
  }

  render() {
    const { shortId } = this.props;
    return (
      <div
        id={shortId}
        className="roo-plus-editor-bar"
      >
        <select
          className="ql-header" defaultValue="false"
        >
          <option value="false">正文</option>
          <option value="2">一级标题</option>
          <option value="3">二级标题</option>
          <option value="4">三级标题</option>
        </select>
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <button className="ql-strike" />
        <select className="ql-color" defaultValue="#000000">
          {this.renderColors()}
        </select>
        <select className="ql-background" defaultValue="#ffffff">
          {this.renderColors()}
        </select>
        <button className="ql-align" value="" />
        <button className="ql-align" value="center" />
        <button className="ql-align" value="right" />
        <button className="ql-list" value="ordered" />
        <button className="ql-list" value="bullet" />

        <button className="ql-indent" value="-1" />
        <button className="ql-indent" value="+1" />
        <button
          className="ql-link"
          onClick={this.showLinkModal}
        />
        <button className="ql-image" />
        {this.renderLinkModal()}
      </div>
    );
  }
}

export default EditorBar;
